import {
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  ViewChild,
  inject
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { assetsConst } from 'src/app/core/const/assets.const';
import {
  FormGroup,
  FormBuilder,
  Validators,
  ReactiveFormsModule
} from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { CountryCodeConst } from 'src/app/core/const/countryCodeConst.const';
import { AuthService } from 'src/app/core/services/auth.service';
import { SpinnerService } from 'src/app/core/services/spinner.service';
import { ToasterService } from 'src/app/core/services/toastr.service';
import { ImageUploadService } from 'src/app/core/services/uploadImage.service';
import { countryCode } from 'src/app/models/countryCode';
import { REGEX } from 'src/app/core/const/regex.constant';
import { VerificationComponent } from '../verification/verification.component';
import { addressChange } from 'src/app/core/helpers/addressChange.helper';
import { NgxAddress } from 'src/app/models/ngxAddress';
import { LoginBody, ProfileDetails } from 'src/app/models/authmodel';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { NgxMatIntlTelInputComponent } from 'ngx-mat-intl-tel-input';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { InitialService } from 'src/app/core/services/initial.service';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare let google: any;

@Component({
  selector: 'megastore-profile-setup',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
    NgxMatIntlTelInputComponent,
    GooglePlaceModule,
    MatDialogModule
  ],
  templateUrl: './profile-setup.component.html',
  styleUrls: ['./profile-setup.component.scss']
})
export class ProfileSetupComponent implements OnInit, OnDestroy {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @ViewChild('phone') phoneField!: ElementRef | any;
  assetsConst = assetsConst;
  countryCodeObject: countryCode = CountryCodeConst;
  destroy$: Subject<boolean> = new Subject<boolean>();
  submitted = false;
  profileSetUpFormGroup: FormGroup;
  EmailVerify = false;
  phoneVerify = false;
  private platFormId = inject(PLATFORM_ID);
  isGoogleMapsReady = false;

  constructor(
    private formBuilder: FormBuilder,
    private _authService: AuthService,
    private _spinnerService: SpinnerService,
    private _uploadImageService: ImageUploadService,
    private _toasterService: ToasterService,
    private _translateService: TranslateService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ProfileSetupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LoginBody,
    private _initialService: InitialService
  ) {
    this.profileSetUpFormGroup = this.formBuilder.group({
      image: [''],
      name: [
        '',
        [Validators.required, Validators.maxLength(40), Validators.minLength(3)]
      ],
      email: ['', [Validators.required, Validators.pattern(REGEX.Email)]],
      dialCode: [''],
      phoneNo: ['', Validators.required],
      // address: [''],
      // latitude: [''],
      // longitude: [''],
      // defaultAddress: true
    });
  }

  async ngOnInit(): Promise<void> {
    // Wait for Google Maps API to be ready
    await this._initialService.waitForGoogleMaps();
    this.isGoogleMapsReady = true;

    if (this.data.phoneNo) {
      this.profileSetUpFormGroup.patchValue({
        phoneNo: `${this.data.dialCode}${this.data.phoneNo}`,
        dialCode: this.data.dialCode
      });

      this.profileSetUpFormGroup.get('phoneNo')?.disable();
      this.profileSetUpFormGroup.get('dialCode')?.disable();
      this.phoneVerify = true;
      this.EmailVerify = false;
    } else if (this.data.email) {
      this.profileSetUpFormGroup.patchValue({
        email: this.data.email
      });

      this.profileSetUpFormGroup.get('email')?.disable();
      this.EmailVerify = true;
      this.phoneVerify = false;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  countryChangedEvent(event: any): void {
    this.countryCodeObject = event;
  }

  patchValues(): ProfileDetails {
    // eslint-disable-next-line prefer-const
    let value: ProfileDetails;
    const patchValueToCountryCode = (): void => {
      let tempCountryCode =
        this.profileSetUpFormGroup['controls']['phoneNo']['value'];

      if (tempCountryCode) {
        tempCountryCode = tempCountryCode.split('');
        tempCountryCode.shift();
        tempCountryCode = tempCountryCode.join('');
      }

      if (tempCountryCode !== this.countryCodeObject['dialCode']) {
        this.profileSetUpFormGroup.patchValue({
          dialCode: `+${this.countryCodeObject['dialCode']}`
        });
      }
    };

    const patchValueToPhoneField = (): void => {
      let phone = this.profileSetUpFormGroup['controls']['phoneNo']['value'];

      if (
        phone &&
        phone.includes(
          this.profileSetUpFormGroup['controls']['dialCode']['value']
        )
      ) {
        phone = phone.split(
          this.profileSetUpFormGroup['controls']['dialCode']['value']
        );
        if (value?.phoneNo !== undefined) {
          value['phoneNo'] = phone[1].trim();
        }
      }
    };
    patchValueToCountryCode();
    value = this.profileSetUpFormGroup['value'];
    patchValueToPhoneField();

    return value;
  }

  openDialog(type: string): void {
    const body = {};
    if (type === 'email') {
      if (this.profileSetUpFormGroup.get('email')?.valid) Object.assign(body, {
        email: this.profileSetUpFormGroup.value.email
      });
    } else {
      const modifiedValue = this.patchValues();
      Object.assign(body, {
        phoneNo: modifiedValue.phoneNo,
        dialCode: modifiedValue.dialCode
      });
    }
    this._authService
      .verifyEmailOrPhone(body)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        const dialogRef = this.dialog.open(VerificationComponent, {
          panelClass: ['modall', 'login_nodal'],
          data: {
            ...body,
            length: 4,
            type
          }
        });

        dialogRef.afterClosed().subscribe((response: ProfileDetails) => {
          if (response) {
            this.handleProfileResponse(response);
          }
        });
      });
  }

  handleProfileResponse(response: ProfileDetails): void {
    if (response.isEmailVerified && response.type !== 'phone') {
      this.EmailVerify = response.isEmailVerified;
      this.profileSetUpFormGroup.get('email')?.disable();
    } else if (response.isPhoneVerified) {
      this.phoneVerify = response.isPhoneVerified;
      this.profileSetUpFormGroup.get('phoneNo')?.disable();
      this.profileSetUpFormGroup.get('dialCode')?.disable();
    }
  }

  onSubmit(): void {
    this.submitted = true;
    this.trimFormFields();
    const modifiedValues = this.patchValues();

    if (this.profileSetUpFormGroup.valid) {
      this.onFormValid(modifiedValues);
    }
  }

  onFormValid(payload: ProfileDetails): void {
    if (!this.checkSubmitValues()) return;
    this._spinnerService.addToLoader('setUpProfile');
    this._authService
      .updateProfile(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: ProfileDetails) => {
          if (isPlatformBrowser(this.platFormId)) {
            this._spinnerService.removeFromLoader('setUpProfile');
            this._toasterService.successToastr(
              this._translateService.instant('ProfileConplete')
            );
            this._authService.profileDetails.next(response);
            sessionStorage.clear();
            this.dialogRef.close();
          }
        },
        error: () => {
          this._spinnerService.removeFromLoader('setUpProfile');
        }
      });
  }

  trimFormFields(): void {
    this.profileSetUpFormGroup.patchValue({
      name: this.profileSetUpFormGroup.get('name')?.value.trim(),
      email: this.profileSetUpFormGroup.get('email')?.value.trim()
    });
  }

  onFileChange(event: Event): void {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this._uploadImageService.onFileChange(event).then((res: any) => {
      if (res !== false) {
        this.profileSetUpFormGroup.patchValue({
          image: res['data'][0].location
        });
      }
    });
  }

  skipProfileForm(): void {
    if (isPlatformBrowser(this.platFormId)) {
      this.profileSetUpFormGroup.disable();
      sessionStorage.clear();
      this.dialogRef.close();
    }
  }

  checkSubmitValues(): boolean {
    let returnValue = true;
    if (
      !this.EmailVerify &&
      this.profileSetUpFormGroup['controls']['email']['value']
    ) {
      this._toasterService.errToastr(
        this._translateService.instant('verifyFirst')
      );
      returnValue = false;
    } else if (
      !this.phoneVerify &&
      this.profileSetUpFormGroup['controls']['phoneNo']['value']
    ) {
      this._toasterService.errToastr(
        this._translateService.instant('verifyPhoneFirst')
      );
      returnValue = false;
    }

    return returnValue;
  }

  handleAddressChange(event: unknown): void {
    if (!this.isGoogleMapsReady) {
      console.warn('Google Maps API is not ready yet');
      return;
    }

    const address: NgxAddress = addressChange(event);

    this.profileSetUpFormGroup.patchValue({
      address: address.address,
      latitude: address.lat,
      longitude: address.lng
    });
  }

  handleKeyDown(event: KeyboardEvent): void {
    if (!this.isGoogleMapsReady) {
      return;
    }

    this.profileSetUpFormGroup.patchValue({
      latitude: '',
      longitude: ''
    });
  }

  ngOnDestroy(): void {
    this.destroy$.complete();
    this.destroy$.unsubscribe();
  }
}
